import { useHistory } from 'react-router-dom';
import Modal from '@components/Modal';
import { Box, Typography, useTheme, useMediaQuery, Link, Checkbox, FormControlLabel  } from '@mui/material';
import { useState } from 'react';
type TaskType = "followup" | "onboarding" | "insurance" | "paymentMethod" | "esign" | "weightManagement" | "weightManagementFollowUp";

interface RemainingTasksModalProps {
  remainingTasks: TaskType[];
  onClose: (dontShowAgain: boolean) => void;
  esignOnSubmit: () => void;
  appointmentId?: string;
  therapyId?: string;
}

const RemainingTasksModal = (props: RemainingTasksModalProps) => {
  const history = useHistory();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [dontShowAgain, setDontShowAgain] = useState(false);

  const tasks: Record<TaskType, { title: string; description: string; onClick: () => void }> = {
    esign: {
      title: "Authorizations",
      description: "Review and sign some important documents",
      onClick: props.esignOnSubmit,
    },
    onboarding: {
      title: "Onboarding Paperwork",
      description: "Complete your onboarding paperwork",
      onClick: () => history.push('forms?formType=newPatient'),
    },
    followup: {
      title: "Follow-Up Paperwork",
      description: "Complete your follow-up paperwork",
      onClick: () => history.push(`forms?formType=followUp&appointmentId=${props.appointmentId}`),
    },
    weightManagement: {
      title: "Weight Management Paperwork",
      description: "Complete your weight management paperwork",
      onClick: () => history.push(`forms?formType=weightManagement&therapyId=${props.therapyId}`),
    },
    weightManagementFollowUp: {
      title: "Weight Management Follow-Up Paperwork",
      description: "Complete your weight management paperwork",
      onClick: () => history.push(`forms?formType=wmFollowUp&therapyId=${props.therapyId}&appointmentId=${props.appointmentId}`),
    },
    insurance: {
      title: "Insurance Setup",
      description: "Complete your insurance information",
      onClick: () => history.push('profile?step=insurance'),
    },
    paymentMethod: {
      title: "Payment Method Setup",
      description: "Add a payment method",
      onClick: () => history.push('profile?step=payment'),
    },
  };

  if (props.remainingTasks.length === 0) {
    return null;
  }

  const firstTask = props.remainingTasks[0];

  return (
    <Modal
      open={true}
      title="Remaining Tasks"
      bodyParagraphs={[
        "To finish setting up your account, you must complete the following tasks:",
        <Box key={`remaining-tasks`} sx={{ textAlign: "left", px: { xs: 0, sm: 2 } }}>
          {props.remainingTasks.map((taskRef) => (
            <Typography variant="body1">
              • {isMobile ? tasks[taskRef].title : <Link component="button" onClick={tasks[taskRef].onClick}>{tasks[taskRef].description}</Link>}
            </Typography>
          ))}
        </Box>,
        <Box>
          <FormControlLabel
            control={<Checkbox checked={dontShowAgain} onChange={(e) => setDontShowAgain(e.target.checked)} size="small" />}
            label="Don't show me this again"
          />
        </Box>
      ]}
      buttons={[
        {
          label: isMobile ? 'Complete next task' : `Continue to ${tasks[firstTask].title}`,
          onClick: () => {
            props.onClose(dontShowAgain);
            tasks[firstTask].onClick();
          },
          variant: "contained",
        },
        {
          label: "Finish Later",
          onClick: () => props.onClose(dontShowAgain),
          variant: "text",
        },
      ]}
    />
  );
};

export default RemainingTasksModal; 